const CheckIcon = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="22" height="22" rx="11" fill="currentBackgroundColor"/>
            <path d="M16.3334 7L9.00008 14.3333L5.66675 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
  };
  
  export default CheckIcon;
  
